module.exports = __webpack_public_path__ + "img/solution24.10c2db51.png";